import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { withNamespaces } from 'react-i18next';
import { FormNext } from 'grommet-icons';
import { withTheme } from 'styled-components';
import { Collapsible } from 'grommet';
import styles from '../../Home.module.scss';

import { Box, Text, ButtonNew, Grid } from 'components/Wrapped';

const StyledLink = styled(Link)`
  color: #46b08e;
  font-weight: 600;

  &:hover {
    color: #46b08e;
    text-decoration: underline;
  }
`;

const questions = [
  {
    id: 'question-1',
    title: 'Как создать аккаунт?',
    description: (
      <Text size="18px">
        Чтобы создать аккаунт, зарегистрируйтесь <StyledLink to="/signup">на странице регистрации</StyledLink>, указав свою электронную
        почту.
      </Text>
    ),
  },
  // {
  //   id: 'question-2',
  //   title: 'Как пройти верификацию?',
  //   description: (
  //     <Text size="18px">
  //       Для прохождения верификации перейдите по{' '}
  //       <StyledLink to="/account/account-verification">ссылке</StyledLink>.
  //     </Text>
  //   ),
  // },
  {
    id: 'question-3',
    title: 'Какие сроки обработки верификации учётной записи на бирже?',
    description: <Text size="18px">Онлайн-верификация обычно занимает до 7 минут.</Text>,
  },
  {
    id: 'question-4',
    title: 'Какие комиссии взимаются за торговлю на бирже?',
    description: (
      <Box pad="none" gap="10px">
        <Text size="18px">Комиссии на пополнение и вывод наличных отсутствуют, помимо комиссии на вывод криптовалюты</Text>
        <Text size="18px">&#x2022; Комиссии на торговые операции зависят от уровня вашего аккаунта </Text>
      </Box>
    ),
  },
  // {
  //   id: 'question-5',
  //   title: 'Как проверить статус пополнения или вывода на бирже?',
  //   description: (
  //     <Text size="18px">
  //       Информация о статусе пополнения и вывода отображается в личном кабинете
  //       в разделе <StyledLink to="/wallet">«История»</StyledLink>.
  //     </Text>
  //   ),
  // },
  {
    id: 'question-6',
    title: 'Как привязать Telegram?',
    description: (
      <Text size="18px">Чтобы привязать Telegram, зайдите в раздел "Профиль" и введите ваш никнейм в соответствующее поле.</Text>
    ),
  },
  {
    id: 'question-7',
    title: 'Вывод средств',
    description: <Text size="18px">Вывод наличных и криптовалюты осуществляется через Личный кабинет на странице вывода.</Text>,
  },
  // {
  //   id: 'question-8',
  //   title: 'Как включить двухфакторную аутентификацию (2FA) на бирже?',
  //   description: (
  //     <Text size="18px">
  //       Для активации 2FA перейдите в{' '}
  //       <StyledLink to="/account/security">настройки</StyledLink> и настройте
  //       через приложение Google Authenticator.
  //     </Text>
  //   ),
  // },
];

const Faq = withNamespaces()(({ t: translate, size }) => {
  // const t = nestedTranslate(translate, 'sections');
  const [activeAccordionId, setActiveAccordionId] = useState();

  const onAccordionHeaderClick = (id) => {
    setActiveAccordionId(id === activeAccordionId ? null : id);
  };

  return (
    <Box
      pad={{
        vertical: size === 'small' ? '20px' : '40px',
        horizontal: size === 'small' ? '16px' : '80px',
      }}
    >
      <Box align="center" justify="center" pad="none" height="100%" width="100%">
        <Grid columns={size === 'small' ? { count: 1 } : ['1fr', '2fr']} gap={size === 'small' ? '30px' : '120px'} pad="none">
          <Box pad="none" direction="column">
            <Box pad="none">
              {size === 'small' ? (
                <div className={styles.faqTitle}>
                  Начни за <span style={{ color: 'white' }}>3 минуты</span>
                </div>
              ) : (
                <>
                  <Text
                    color="#777E83"
                    size={size === 'small' ? '36px' : '56px'}
                    weight="bold"
                    style={{
                      lineHeight: '56px',
                      textAlign: size === 'small' ? 'center' : 'left',
                    }}
                  >
                    Начни за
                  </Text>
                  <Text
                    color="white"
                    size={size === 'small' ? '36px' : '56px'}
                    margin={{ bottom: '16px' }}
                    weight="bold"
                    style={{
                      lineHeight: '56px',
                      textAlign: size === 'small' ? 'center' : 'left',
                    }}
                  >
                    3 минуты
                  </Text>
                </>
              )}
              <Text
                color="#B4B6B7"
                size={size === 'small' ? '16px' : '20px'}
                style={{
                  lineHeight: size === 'small' ? '22.4px' : '26px',
                  textAlign: size === 'small' ? 'center' : 'left',
                }}
              >
                Откройте для себя самый интуитивный и непревзойденный пользовательский опыт на IBEX
              </Text>
            </Box>
            {size !== 'small' && (
              <Box pad="none" direction="row" gap="8px" margin={{ top: 'auto' }}>
                <Link to="/signup">
                  <ButtonNew label="Зарегистрироваться" buttonSize="large" width="200px" />
                </Link>
                <Link to="/login">
                  <ButtonNew label="Войти" theme="gray" buttonSize="large" width="140px" />
                </Link>
              </Box>
            )}
          </Box>
          <Box gap={size === 'small' ? '12px' : '20px'} pad="none">
            {questions.map((item) => (
              <Box key={item.id} background="background-6" round="16px" pad="none">
                <Box
                  justify="between"
                  direction="row"
                  pad={{
                    horizontal: size === 'small' ? '16px' : '24px',
                    vertical: size === 'small' ? '25px' : '33px',
                  }}
                  style={{ cursor: 'pointer', userSelect: 'none' }}
                  onClick={() => onAccordionHeaderClick(item.id)}
                >
                  <Text size={size === 'small' ? '16px' : '21px'} weight="bold">
                    {item.title}
                  </Text>
                  <FormNext
                    style={{
                      transform: activeAccordionId === item.id ? 'rotate(90deg)' : '',
                      transition: 'transform 0.2s',
                    }}
                  />
                </Box>
                <Collapsible open={activeAccordionId === item.id}>
                  <Box pad={{ horizontal: '24px', top: '0px', bottom: '33px' }}>{item.description}</Box>
                </Collapsible>
              </Box>
            ))}

            {size === 'small' && (
              <Box pad="none" direction="row" gap="8px" margin={{ left: 'auto', right: 'auto', top: '18px' }}>
                <Link to="/signup">
                  <ButtonNew label="Зарегистрироваться" buttonSize="large" width="200px" />
                </Link>
                <Link to="/login">
                  <ButtonNew label="Войти" theme="gray" buttonSize="large" width="140px" />
                </Link>
              </Box>
            )}
          </Box>
        </Grid>
      </Box>
    </Box>
  );
});

const mapStateToProps = ({
  exchangeSettings: {
    settings: {
      seo: { reCaptchaKey },
    },
  },
}) => ({ reCaptchaKey });

export default withTheme(connect(mapStateToProps)(Faq));
